<template>
  <div class="section_12 flex-col">
    <div class="text-group_18 flex-col justify-between">
      <span class="text_38">合作品牌</span>
    </div>
    <div class="grid_2 flex-row">
      <div class="list-items_2-0 flex-col"></div>
      <div class="list-items_2-1 flex-col"></div>
      <div class="list-items_2-2 flex-col"></div>
      <div class="list-items_2-3 flex-col"></div>
      <div class="list-items_2-4 flex-col"></div>
      <div class="list-items_2-5 flex-col"></div>
    </div>
    <div class="grid_3 flex-row">
      <div class="list-items_2-6 flex-col"></div>
      <div class="list-items_2-7 flex-col"></div>
      <div class="list-items_2-8 flex-col"></div>
      <div class="list-items_2-9 flex-col"></div>
      <div class="list-items_2-10 flex-col"></div>
      <div class="list-items_2-11 flex-col"></div>
    </div>
  </div>
  <div class="section_13 flex-col">
    <div class="text-wrapper_12 flex-row">
          <span class="paragraph_7"
          >小易装修之家打造线上拼建材、团家具、买家电、赏案例、选设计、挑工长，专注本土家装一站式服务的互联网严选平台。<br/>品质家装、大牌建材、家居生活尽在小易装修之家!让鹰城更美好!</span
          >
    </div>
    <div class="text-wrapper_13 flex-row">
      <span class="text_41">联系热线:</span>
      <span class="text_42">15886707351</span>
<!--      <span class="text_43">公司邮箱:</span>-->
<!--      <span class="text_44">xyjzw&#64;163.com</span>-->
      <span class="text_45"
      >营业执照:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;91410400MADCXEH83H</span
      >
    </div>
    <div class="text-wrapper_13 flex-row">
      <span class="text_41">公司主体:</span>
      <span class="text_42">平顶山市大山企业管理服务有限公司</span>
      <span class="text_45">备案号:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;豫ICP备2024102760号</span>
<!--      <span class="text_43" style="font-size: 0">域名:</span>-->
<!--      <span class="text_44" style="font-size: 0">xyjzw.top</span>-->
    </div>
  </div>
</template>

<script>

export default {
  name: 'HezuopinpaiView',
  data() {
    return {
      newsList: [],
      isLoading: true,
      error: null,
      startX: null,
      startY: null,
    };
  },
  methods: {
    // 新增触摸事件处理
    handleTouchStart(e) {
      this.startY = e.touches[0].clientY;
    },
    handleTouchEnd(e) {
      if (!this.startY) return;
      const endY = e.changedTouches[0].clientY;
      const deltaY = endY - this.startY;
      const deltaX = Math.abs(e.changedTouches[0].clientX - this.startX);
      console.log('1',deltaY,deltaX,Math.abs(deltaY))

      // 垂直滑动距离大于30px且水平滑动小于50px时才触发
      if (Math.abs(deltaY) > 50 && deltaX < 400) {
        if (deltaY > 0) { // 向下滑动
          this.$router.push('/member-list.html'); // 跳转
        } else if (deltaY < 0) { // 向上滑动
        }
      }
      this.startY = null;
    },
    handleWheelScroll(e) {
      if (e.ctrlKey || e.metaKey) return; // 过滤组合键操作

      if (e.deltaY > 0) { // 检测向下滚动
      }else if (e.deltaY < 0) { // 检测向上滚动
        this.$router.push('/member-list.html'); // 跳转
      }
    },
    handleKeyDown(e) {
      // 阻止Ctrl+加号/减号/鼠标滚轮
      if ((e.ctrlKey === true || e.metaKey) &&
          (e.keyCode === 61 || e.keyCode === 107 ||
              e.keyCode === 173 || e.keyCode === 109 ||
              e.keyCode === 187  || e.keyCode === 189)) {
        e.preventDefault();
      }
    },
    handleWheel(e) {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    },
    handleTouchMove(e) {
      if (e.scale !== 1) {
        e.preventDefault();
      }
    },
  },
  mounted() {
    // 添加触摸事件监听
    document.addEventListener('touchstart', this.handleTouchStart, { passive: false });
    document.addEventListener('touchend', this.handleTouchEnd, { passive: false });
    window.addEventListener('wheel', this.handleWheelScroll);
    // 禁用快捷键缩放
    document.addEventListener('keydown', this.handleKeyDown);
    // 禁用双指缩放（移动端）
    document.addEventListener('wheel', this.handleWheel, { passive: false });
    // 禁用触摸事件缩放
    document.addEventListener('touchmove', this.handleTouchMove, { passive: false });
  },
  beforeUnmount() {
    // 移除触摸事件监听
    document.removeEventListener('touchstart', this.handleTouchStart);
    document.removeEventListener('touchend', this.handleTouchEnd);
    // 移除滚轮事件监听
    window.removeEventListener('wheel', this.handleWheelScroll);
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('wheel', this.handleWheel);
    document.removeEventListener('touchmove', this.handleTouchMove);
  },
  computed: {
    containerStyle() {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: 'top left',
        width: `${100 / this.scale}%`,
        height: `${100 / this.scale}%`
      };
    }
  },
};
</script>

<style>
@media (max-width: 768px) {
  .section_12 {
    z-index: 0!important;
  }
  .grid_2 {
    margin-top: -380px !important;
    margin-left: -70px !important;
    display: flex;
    width: 100%;
    flex-wrap: wrap; /* 禁止换行 */
    gap: 15px;
    padding: 20px 0;
    justify-content: center;
    align-items: center;
    transform: scale(0.48) !important;
  }
  .grid_3 {
    margin-top: -875px !important;
    margin-left: 70px !important;
    display: flex;
    width: 100%;
    flex-wrap: wrap; /* 禁止换行 */
    gap: 15px;
    padding: 20px 0;
    justify-content: center;
    align-items: center;
    transform: scale(0.48) !important;
  }
  .text_38 {
    width: 100%;
    height: 189px!important;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 4vw;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    line-height: 39px;
  }
  .section_12 {
    background-image: url(../assets/hezuobeijing.webp);
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 75vh !important;
    background-size: cover;
    background-position: center;
    z-index: -1;
  }
  .section_13 {
    background: url(../assets/hezuopinpai/beijingtu1.webp) 100% no-repeat;
    position: fixed;
    top: 75% !important;
    left: 0;
    width: 100vw;
    height: 41vh !important;
    background-size: cover;
    background-position: center;
    z-index: -1;
    display: flex;
    flex-direction: column;
    align-items: center; /* 新增水平居中 */
    justify-content: flex-start !important; /* 新增垂直居中 */
  }

  .text-wrapper_12 {
    width: 95%; /* 调整宽度 */
    margin: 0 0 0 0 !important;
    text-align: center; /* 新增文本居中 */
  }
  .paragraph_7 {
    width: 709px;
    height: 34px;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 11px !important;
    font-family: PingFangSC-Regular;
    font-weight: normal;
    text-align: right;
    line-height: 5px !important;
  }
  .text-wrapper_13 {
    width: 90% !important;
    display: flex;
    flex-wrap: wrap;
    justify-content: left !important; /* 新增水平居中 */
    gap: 0px !important;
    margin: 0px 0 0 50px !important; /* 调整边距 */
  }
  .text_42 {
    font-size: 11px !important;
    margin-left: 20px !important;
  }
  .text_41 {
    width: 50px;
    height: 7px !important;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    font-family: PingFangSC-Regular;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 17px !important;
    margin: 3px 0 0 54px;
  }
  .text_44 {
    margin-left: 20px !important;
  }
}

.section_12 {
  background-image: url(../assets/hezuobeijing.webp);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 78vh;
  background-size: cover;
  background-position: center;
  z-index: -1;
}
.section_13 {
  background: url(../assets/hezuopinpai/beijingtu1.webp) 100% no-repeat;
  position: fixed;
  top: 78%;
  left: 0;
  width: 100vw;
  height: 22vh;
  background-size: cover;
  background-position: center;
  z-index: -1;
  display: flex;
  flex-direction: column;
  align-items: center; /* 新增水平居中 */
  justify-content: center; /* 新增垂直居中 */
}
.text-group_18 {
  width: 80%;
  height: 201px;
  margin: 100px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.text_38 {
  width: 100%;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 4vw;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 39px;
}

.grid_2 {
  margin-top: 10px;
  display: flex;
  width: 100%;
  flex-wrap: wrap; /* 禁止换行 */
  gap: 15px;
  padding: 20px 0;
  justify-content: center;
  align-items: center;
}
.grid_3 {
  margin-top: 10px;
  display: flex;
  width: 100%;
  flex-wrap: wrap; /* 禁止换行 */
  gap: 15px;
  padding: 20px 0;
  justify-content: center;
  align-items: center;
}
[class^="list-items_2-"] {
  flex: 0 0 266px; /* 固定卡片宽度 */
  height: 145px;
  border: 0.775px solid rgba(204, 204, 204, 0.55);
  margin: 0 !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-items_2-0 {
  background: url('../assets/hezuopinpai/11.png') center/cover; /* 添加本地背景图 */
  width: 216px;
  height: 125px;
  border: 0.775px solid rgba(204, 204, 204, 0.55);
  margin: 0 20px 20px 0;
}

.list-items_2-1 {
  background: url('../assets/hezuopinpai/10.png') center/cover; /* 添加本地背景图 */
  width: 216px;
  height: 125px;
  border: 0.775px solid rgba(204, 204, 204, 0.55);
  margin: 0 20px 20px 0;
}

.list-items_2-2 {
  background: url('../assets/hezuopinpai/zhonghe.png') center/cover; /* 添加本地背景图 */
  width: 216px;
  height: 125px;
  border: 0.775px solid rgba(204, 204, 204, 0.55);
  margin: 0 20px 20px 0;
}

.list-items_2-3 {
  background: url('../assets/hezuopinpai/1.png') center/cover; /* 添加本地背景图 */
  width: 216px;
  height: 125px;
  border: 0.775px solid rgba(204, 204, 204, 0.55);
  margin: 0 20px 20px 0;
}

.list-items_2-4 {
  background: url('../assets/hezuopinpai/2.png') center/cover; /* 添加本地背景图 */
  width: 216px;
  height: 125px;
  border: 0.775px solid rgba(204, 204, 204, 0.55);
  margin: 0 20px 20px 0;
}

.list-items_2-5 {
  background: url('../assets/hezuopinpai/3.png') center/cover; /* 添加本地背景图 */
  width: 216px;
  height: 125px;
  border: 0.775px solid rgba(204, 204, 204, 0.55);
  margin: 0 20px 20px 0;
  margin-right: 0;
}

.list-items_2-6 {
  background: url('../assets/hezuopinpai/4.png') center/cover; /* 添加本地背景图 */
  width: 216px;
  height: 125px;
  border: 0.775px solid rgba(204, 204, 204, 0.55);
  margin: 0 20px 20px 0;
  margin-bottom: 0;
}

.list-items_2-7 {
  background: url('../assets/hezuopinpai/5.png') center/cover; /* 添加本地背景图 */
  width: 186px;
  height: 125px;
  border: 0.775px solid rgba(204, 204, 204, 0.55);
  margin: 0 20px 20px 0;
  margin-bottom: 0;
}

.list-items_2-8 {
  background: url('../assets/hezuopinpai/6.png') center/cover; /* 添加本地背景图 */
  width: 216px;
  height: 125px;
  border: 0.775px solid rgba(204, 204, 204, 0.55);
  margin: 0 20px 20px 0;
  margin-bottom: 0;
}

.list-items_2-9 {
  background: url('../assets/hezuopinpai/7.png') center/cover; /* 添加本地背景图 */
  width: 186px;
  height: 125px;
  border: 0.775px solid rgba(204, 204, 204, 0.55);
  margin: 0 20px 20px 0;
  margin-bottom: 0;
}

.list-items_2-10 {
  background: url('../assets/hezuopinpai/8.png') center/cover; /* 添加本地背景图 */
  width: 186px;
  height: 125px;
  border: 0.775px solid rgba(204, 204, 204, 0.55);
  margin: 0 20px 20px 0;
  margin-bottom: 0;
}

.list-items_2-11 {
  background: url('../assets/hezuopinpai/9.png') center/cover; /* 添加本地背景图 */
  width: 186px;
  height: 125px;
  border: 0.775px solid rgba(204, 204, 204, 0.55);
  margin: 0 20px 20px 0;
  margin-right: 0;
  margin-bottom: 0;
}


.text-wrapper_12 {
  width: 80%; /* 调整宽度 */
  margin: 20px 0 0 0; /* 修改边距 */
  text-align: center; /* 新增文本居中 */

}

.paragraph_7 {
  width: 709px;
  height: 34px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 13px;
  font-family: PingFangSC-Regular;
  font-weight: normal;
  text-align: right;
  line-height: 17px;
}

.text-wrapper_13 {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center; /* 新增水平居中 */
  gap: 15px; /* 新增元素间距 */
  margin: 10px 0; /* 调整边距 */
}

.text_41 {
  width: 50px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 17px;
  margin: 3px 0 0 54px;
}

.text_42 {
  width: 203px;
  height: 21px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 21px;
  margin-left: 7px;
}

.text_43 {
  width: 50px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 17px;
  margin: 3px 0 0 54px;
}

.text_44 {
  width: 115px;
  height: 21px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 21px;
  margin-left: 8px;
}

.text_45 {
  width: 205px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 17px;
  margin: 3px 0 0 54px;
}
</style>